<template>
    <div class="demo-container" ref="container">
        <div class="demo" :data-noscroll="overlayPanel?true:false" :data-guided="guidedMode" :data-show-links="showLinks">

            <div class="screens">

                <!-- DASHBOARD -->
                <div class="screen" data-screen="dashboard" :data-active="currentScreen=='dashboard'">
                    <img class="w-full max-w-100" src="/img/screens/hb-employee-dashboard.png" />
                    <div class="links">



                        <screen-link left="49%" top="60%" width="16%" height="4%" data-tgt="hb-enrollment-begin" href="https://demo.paychex.com/benefits/enrollment" target="_top"></screen-link>
                        <screen-link left="27.5%" top="21%" width="19%" height="10%" data-tgt="hb-summary" @click.native="onLinkClick"></screen-link>





                    </div>
                </div>




                <!-- SUMMARY -->
                <div class="screen" data-screen="hb-summary" :data-active="currentScreen=='hb-summary'">
                    <img class="w-full max-w-100" src="/img/screens/hb-employee-gail-post-enrollment.png" />
                    <div class="links">
                        <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-summary" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="20.3%" top="18.5%" width="3.5%" height="3%" data-tgt="hb-family" @click.native="onLinkClick"></screen-link>
                        <screen-link dot-class="dot-top-center" left="24%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                      <screen-link left="68%" top="24%" width="19%" height="10%" data-tgt="hb-qe-begin" @click.native="onLinkClick"></screen-link>

                        <screen-link left="68%" top="36.5%" width="19%" height="10%" data-tgt="hb-summary-documents" @click.native="onLinkClick"></screen-link>


                      <screen-link left="28%" top="38.5%" width="38%" height="6%" data-tgt="hb-summary-medical" @click.native="onLinkClick"></screen-link>
                      <screen-link left="28%" top="51%" width="38%" height="6%" data-tgt="hb-summary-ENI" @click.native="onLinkClick"></screen-link>










                    </div>
                </div>

              <div class="screen" data-screen="hb-summary-medical" :data-active="currentScreen=='hb-summary-medical'">
                <img class="w-full max-w-100" src="/img/screens/hb-employee-gail-post-enrollment-medical.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-summary" @click.native="onLinkClick"></screen-link>
                  <screen-link left="65%" top="20%" width="15%" height="11.5%" data-tgt="hb-summary-medical-pdf" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen z-max" data-screen="hb-summary-medical-pdf" :data-active="currentScreen=='hb-summary-medical-pdf'">
                <img class="w-full max-w-100" src="/img/screens/hb-summary-medical-pdf.png" />
                <div class="links">

                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-summary-medical" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-summary-life" :data-active="currentScreen=='hb-summary-life'">
                <img class="w-full max-w-100" src="/img/screens/hb-employee-gail-post-enrollment-life.png" />
                <div class="links">

                  <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-summary" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen z-max" data-screen="hb-summary-ENI" :data-active="currentScreen=='hb-summary-ENI'">
                <img class="w-full max-w-100" src="/img/screens/eni-plan-pdf.png" />
                <div class="links">

                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-summary" @click.native="onLinkClick"></screen-link>

                </div>
              </div>




              <!-- DOCUMENTS -->

                <div class="screen" data-screen="hb-summary-documents" :data-active="currentScreen=='hb-summary-documents'">
                    <img class="w-full max-w-100" src="/img/screens/hb-employee-gail-post-enrollment-documents.png" />
                    <div class="links">

                        <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="hb-summary" @click.native="onLinkClick"></screen-link>
                      <screen-link left="64%" top="16.5%" width="25%" height="5%" data-tgt="hb-summary-documents-registration" @click.native="onLinkClick"></screen-link>
                    </div>
                </div>

              <div class="screen z-max" data-screen="hb-summary-documents-registration" :data-active="currentScreen=='hb-summary-documents-registration'">
                <img class="w-full max-w-100" src="/img/screens/online-registration-pdf.png" />
                <div class="links">

                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-summary-documents" @click.native="onLinkClick"></screen-link>

                </div>
              </div>



                <!-- FAMILY -->

              <div class="screen" data-screen="hb-family" :data-active="currentScreen=='hb-family'">
                <img class="w-full max-w-100" src="/img/screens/hb-employee-gail-post-enrollment-family.png" />
                <div class="links">
                  <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-summary" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="20.3%" top="18.5%" width="3.5%" height="3%" data-tgt="hb-family" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="24%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                </div>
              </div>


                <!-- HISTORY -->

              <div class="screen" data-screen="hb-history" :data-active="currentScreen=='hb-history'">
                <img class="w-full max-w-100" src="/img/screens/hb-employee-gail-post-enrollment-history.png" />
                <div class="links">
                  <screen-link dot-class="dot-top-center" left="15.4%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-summary" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="20.3%" top="18.5%" width="3.5%" height="3%" data-tgt="hb-family" @click.native="onLinkClick"></screen-link>
                  <screen-link dot-class="dot-top-center" left="24%" top="18.5%" width="4.5%" height="3%" data-tgt="hb-history" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <!-- QUALIFYING EVENT -->



              <div class="screen" data-screen="hb-qe-begin" :data-active="currentScreen=='hb-qe-begin'">
                <img class="w-full max-w-100" src="/img/screens/hb-qe-begin.png" />
                <div class="links">
                  <screen-link left="78%" top="61.5%" width="7%" height="6%" data-tgt="hb-qe-select" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-qe-select" :data-active="currentScreen=='hb-qe-select'">
                <img class="w-full max-w-100" src="/img/screens/hb-qe-select.png" />
                <div class="links">
                  <screen-link left="30%" top="60%" width="26%" height="13.5%" data-tgt="hb-qe-date" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-qe-date" :data-active="currentScreen=='hb-qe-date'">
                <img class="w-full max-w-100" src="/img/screens/hb-qe-date.png" />
                <div class="links">
                  <screen-link left="27%" top="82.5%" width="7%" height="6%" data-tgt="hb-qe-select" @click.native="onLinkClick"></screen-link>

                  <screen-link left="80%" top="82.5%" width="7%" height="6%" data-tgt="hb-qe-documentation" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-qe-documentation" :data-active="currentScreen=='hb-qe-documentation'">
                <img class="w-full max-w-100" src="/img/screens/hb-qe-documentation.png" />
                <div class="links">
                  <screen-link left="27%" top="99%" width="7%" height="6%" data-tgt="hb-qe-date" @click.native="onLinkClick"></screen-link>

                  <screen-link left="80%" top="99%" width="7%" height="6%" data-tgt="hb-qe-dependents" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-qe-dependents" :data-active="currentScreen=='hb-qe-dependents'">
                <img class="w-full max-w-100" src="/img/screens/hb-qe-dependents.png" />
                <div class="links">

                  <screen-link left="27%" top="84%" width="7%" height="6%" data-tgt="hb-qe-documentation" @click.native="onLinkClick"></screen-link>


                  <screen-link left="79%" top="60%" width="7%" height="6%" data-tgt="hb-qe-dependents-add" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-qe-dependents-add" :data-active="currentScreen=='hb-qe-dependents-add'">
                <img class="w-full max-w-100" src="/img/screens/hb-qe-dependents-add.png" />
                <div class="links">
                  <screen-link left="91%" top="7%" width="6%" height="5%" data-tgt="hb-qe-dependents-added" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-qe-dependents-added" :data-active="currentScreen=='hb-qe-dependents-added'">
                <img class="w-full max-w-100" src="/img/screens/hb-qe-dependents-added.png" />
                <div class="links">
                  <screen-link left="27%" top="92%" width="7%" height="6%" data-tgt="hb-qe-documentation" @click.native="onLinkClick"></screen-link>
                  <screen-link left="80%" top="92%" width="7%" height="6%" data-tgt="hb-qe-medical" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-qe-medical" :data-active="currentScreen=='hb-qe-medical'">
                <img class="w-full max-w-100" src="/img/screens/hb-qe-medical.png" />
                <div class="links">
                  <screen-link left="27%" top="165.5%" width="7%" height="6%" data-tgt="hb-qe-dependents-added" @click.native="onLinkClick"></screen-link>
                  <screen-link left="80%" top="165.5%" width="7%" height="6%" data-tgt="hb-qe-review" @click.native="onLinkClick"></screen-link>
                </div>
              </div>

              <div class="screen" data-screen="hb-qe-review" :data-active="currentScreen=='hb-qe-review'">
                <img class="w-full max-w-100" src="/img/screens/hb-qe-review.png" />
                <div class="links">
                  <screen-link left="27%" top="121%" width="7%" height="6%" data-tgt="hb-qe-medical" @click.native="onLinkClick"></screen-link>
                  <screen-link left="80%" top="121%" width="7%" height="6%" data-tgt="hb-qe-confirmation" @click.native="onLinkClick"></screen-link>

                </div>
              </div>

              <div class="screen" data-screen="hb-qe-confirmation" :data-active="currentScreen=='hb-qe-confirmation'">
                <img class="w-full max-w-100" src="/img/screens/hb-qe-confirmation.png" />
                <div class="links">
                  <screen-link left="53.5%" top="55%" width="7%" height="6%" data-tgt="hb-summary" @click.native="onLinkClick"></screen-link>

                </div>
              </div>



<!--              <div class="screen" data-screen="hb-enrollment-change-medical" :data-active="currentScreen=='hb-enrollment-change-medical'">-->
<!--                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-change-medical.png" />-->
<!--                <div class="links">-->

<!--                  <screen-link left="73%" top="199%" width="6.5%" height="6%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>-->

<!--                </div>-->
<!--              </div>-->

<!--              <div class="screen" data-screen="hb-enrollment-review-edit-beneficiary" :data-active="currentScreen=='hb-enrollment-review-edit-beneficiary'">-->
<!--                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-review-edit-beneficiary.png" />-->
<!--                <div class="links">-->

<!--                  <screen-link left="85%" top="7%" width="6%" height="5.5%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>-->
<!--                  <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="screen" data-screen="hb-enrollment-review-legal-notice" :data-active="currentScreen=='hb-enrollment-review-legal-notice'">-->
<!--                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-review-legal-notice.png" />-->
<!--                <div class="links">-->


<!--                  <screen-link left="97%" top="7%" width="2.5%" height="5%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="screen" data-screen="hb-enrollment-review-accept" :data-active="currentScreen=='hb-enrollment-review-accept'">-->
<!--                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-review-accept.png" />-->
<!--                <div class="links">-->

<!--                  <screen-link left="79%" top="59%" width="7%" height="5.75%" data-tgt="hb-enrollment-change-medical" @click.native="onLinkClick"></screen-link>-->
<!--                  <screen-link left="79%" top="85.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-review-edit-beneficiary" @click.native="onLinkClick"></screen-link>-->

<!--                  <screen-link left="27.5%" top="120.5%" width="6.5%" height="6%" data-tgt="hb-enrollment-beneficiaries-added" @click.native="onLinkClick"></screen-link>-->
<!--                  <screen-link left="57%" top="120.5%" width="3%" height="5.75%" data-tgt="hb-enrollment-review" @click.native="onLinkClick"></screen-link>-->
<!--                  <screen-link left="70.5%" top="120.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-review-legal-notice" @click.native="onLinkClick"></screen-link>-->
<!--                  <screen-link left="80%" top="120.5%" width="7%" height="5.75%" data-tgt="hb-enrollment-confirmation" @click.native="onLinkClick"></screen-link>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="screen" data-screen="hb-enrollment-confirmation" :data-active="currentScreen=='hb-enrollment-confirmation'">-->
<!--                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-confirmation.png" />-->
<!--                <div class="links">-->

<!--                  <screen-link left="50%" top="50%" width="15%" height="5%" data-tgt="hb-enrollment-confirmation-pdf" @click.native="onLinkClick"></screen-link>-->
<!--                  <screen-link left="54%" top="55%" width="6.5%" height="5.75%" data-tgt="hb-employee-post-enrollment" @click.native="onLinkClick"></screen-link>-->


<!--                </div>-->
<!--              </div>-->

<!--              <div class="screen z-max" data-screen="hb-enrollment-confirmation-pdf" :data-active="currentScreen=='hb-enrollment-confirmation-pdf'">-->
<!--                <img class="w-full max-w-100" src="/img/screens/hb-enrollment-gail-confirmation-pdf.png" />-->
<!--                <div class="links">-->

<!--                  <screen-link left="1%" top="1%" width="98%" height="98%" data-tgt="hb-enrollment-confirmation" @click.native="onLinkClick"></screen-link>-->


<!--                </div>-->
<!--              </div>-->

<!--              <div class="screen" data-screen="hb-employee-post-enrollment" :data-active="currentScreen=='hb-employee-post-enrollment'">-->
<!--                <img class="w-full max-w-100" src="/img/screens/hb-employee-gail-post-enrollment.png" />-->
<!--                <div class="links">-->

<!--                  <screen-link left="50%" top="50%" width="15%" height="5%" data-tgt="hb-enrollment-confirmation-pdf" @click.native="onLinkClick"></screen-link>-->
<!--                  <screen-link left="54%" top="55%" width="6.5%" height="5.75%" data-tgt="hb-post-enrollment" @click.native="onLinkClick"></screen-link>-->


<!--                </div>-->
<!--              </div>-->







            </div>

          <!--EMPLOYEE PULLOUT TERRI -->

          <div class="pullout" data-screen="hb-employees-trent" :data-active="pulloutPanel=='hb-employees-trent'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>
              <screen-link left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-family" @click.native="showPullout"></screen-link>
              <screen-link left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-history" @click.native="showPullout"></screen-link>
              <screen-link left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-trent-employee" @click.native="showPullout"></screen-link>

              <screen-link left="63.5%" top="33.5%" width="35%" height="6%" data-tgt="hb-employees-trent-plans-medical" @click.native="showPullout"></screen-link>
              <screen-link left="63.5%" top="39.5%" width="35%" height="7%" data-tgt="hb-employees-trent-plans-ENI" @click.native="showPullout"></screen-link>
            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-trent-plans-medical" :data-active="pulloutPanel=='hb-employees-trent-plans-medical'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent-plans.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="7.5%" width="9%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-trent-plans-ENI" :data-active="pulloutPanel=='hb-employees-trent-plans-ENI'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent-plans-ENI.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="7.5%" width="9%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-trent-family" :data-active="pulloutPanel=='hb-employees-trent-family'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent-family.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>
              <screen-link left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-family" @click.native="showPullout"></screen-link>
              <screen-link left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-history" @click.native="showPullout"></screen-link>
              <screen-link left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-trent-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-trent-history" :data-active="pulloutPanel=='hb-employees-trent-history'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent-history.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>
              <screen-link left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-family" @click.native="showPullout"></screen-link>
              <screen-link left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-history" @click.native="showPullout"></screen-link>
              <screen-link left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-trent-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-trent-employee" :data-active="pulloutPanel=='hb-employees-trent-employee'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-trent-employee.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-trent" @click.native="showPullout"></screen-link>
              <screen-link left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-family" @click.native="showPullout"></screen-link>
              <screen-link left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-trent-history" @click.native="showPullout"></screen-link>
              <screen-link left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-trent-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <!--EMPLOYEE PULLOUT GAIL -->




          <div class="pullout" data-screen="hb-employees-gail" :data-active="pulloutPanel=='hb-employees-gail'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
              <screen-link left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-family" @click.native="showPullout"></screen-link>
              <screen-link left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-history" @click.native="showPullout"></screen-link>
              <screen-link left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-gail-employee" @click.native="showPullout"></screen-link>

              <screen-link left="63.5%" top="78.5%" width="35%" height="6%" data-tgt="hb-employees-gail-plans-dental" @click.native="showPullout"></screen-link>
              <screen-link left="63.5%" top="84%" width="35%" height="7%" data-tgt="hb-employees-gail-plans-vision" @click.native="showPullout"></screen-link>
              <screen-link left="63.5%" top="91%" width="35%" height="7%" data-tgt="hb-employees-gail-plans-ENI" @click.native="showPullout"></screen-link>
            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-plans-dental" :data-active="pulloutPanel=='hb-employees-gail-plans-dental'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-plans-dental.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="7.5%" width="9%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-plans-vision" :data-active="pulloutPanel=='hb-employees-gail-plans-vision'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-plans-vision.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="7.5%" width="9%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-plans-ENI" :data-active="pulloutPanel=='hb-employees-gail-plans-ENI'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-plans-ENI.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="7.5%" width="9%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-family" :data-active="pulloutPanel=='hb-employees-gail-family'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-family.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
              <screen-link left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-family" @click.native="showPullout"></screen-link>
              <screen-link left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-history" @click.native="showPullout"></screen-link>
              <screen-link left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-gail-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-history" :data-active="pulloutPanel=='hb-employees-gail-history'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-history.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
              <screen-link left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-family" @click.native="showPullout"></screen-link>
              <screen-link left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-history" @click.native="showPullout"></screen-link>
              <screen-link left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-gail-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>

          <div class="pullout" data-screen="hb-employees-gail-employee" :data-active="pulloutPanel=='hb-employees-gail-employee'">
            <img class="pullout-1200 max-w-100" src="/img/screens/hb-employees-gail-employee.png" />
            <div class="links">
              <screen-link left="97%" top="7.5%" width="2.5%" height="4%" data-tgt="" @click.native="onLinkClick"></screen-link>

              <screen-link left="62%" top="13%" width="4.25%" height="4%" data-tgt="hb-employees-gail" @click.native="showPullout"></screen-link>
              <screen-link left="66.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-family" @click.native="showPullout"></screen-link>
              <screen-link left="70.25%" top="13%" width="3.75%" height="4%" data-tgt="hb-employees-gail-history" @click.native="showPullout"></screen-link>
              <screen-link left="74.25%" top="13%" width="4.75%" height="4%" data-tgt="hb-employees-gail-employee" @click.native="showPullout"></screen-link>

            </div>
          </div>


          <!-- HEADER NAV OVERLAYS -->


            <div class="overlay" data-screen="news" :data-active="overlayPanel=='news'">
                <img class="w-full max-w-100" src="/img/screens/sidepanel-news.png" />
                <div class="links">
                    <screen-link left="87%" top="1.5%" width="10%" height="4%" data-tgt="" data-is-overlay="true" @click.native="onLinkClick"></screen-link>



                </div>
            </div>

            <div class="overlay" data-screen="messages" :data-active="overlayPanel=='messages'">
                <img class="w-full max-w-100" src="/img/screens/sidepanel-messages.png" />
                <div class="links">
                    <screen-link left="90%" top="1%" width="10%" height="4%" data-tgt="" data-is-overlay="true" @click.native="onLinkClick"></screen-link>

                </div>
            </div>


            <flex-nav-top-bar class="z-40" :data-hidden="!visibility.topnav"  @nav-click="onTopNavLink"></flex-nav-top-bar>
            <flex-side-nav  :data-hidden="!visibility.topnav" @nav-click="onSideNavLink" :active-link="sideNavLink" :mode="sideNavMode"></flex-side-nav>
        </div>
        <demo-menu v-if="showMenu" @fullscreen="goFullscreen"></demo-menu>
    </div>

</template>

<script>
    import ScreenLink from "../components/ScreenLink";
    //import FiltersPanel from "../components/FiltersPanel";

    import FlexNavTopBar from "../components/FlexNavTopBar";
    import FlexSideNav from "../components/FlexEmployeeSideNav";
    //import InfoBox from "../components/InfoBox";
    //import SelectBox from "@/components/SelectBox";
    //import FlexInfo from "@/components/FlexInfo";
    import DemoMenu from "@/components/DemoMenu";
    export default {
        name: "employee-screens",
        components: {DemoMenu, FlexSideNav, FlexNavTopBar, ScreenLink },
        mounted: function(){
            window.addEventListener('keydown',this.onKeyDown);
            window.addEventListener('keyup',this.onKeyUp);
        },
        props: {},
        data: function () {
            return {
                defaultScreen: 'dashboard',
                visibility: {
                    topnav: true
                },
                overlayPanel: null,
                pulloutPanel: null,
                disableScreenScoll: false,
                showLinks: false,


                employeeSelections: [
                  { label: "All Employees", tgt: "hb-employees-all"},
                  { label: "Newly Eligible", tgt: "hb-employees-newly"},
                  { label: "Annual Enrollment", tgt: "hb-employees-annual"},
                  { label: "Current Enrollment", tgt: "hb-employees-current"},
                  { label: "Future Enrollment", tgt: "hb-employees-future"},
                  { label: "Missing Information", tgt: "hb-employees-missing"},

                ],

              planClassificationsMedical: [
                { label: "MANAGEMENT", tgt: "hb-plans-medical"},
                { label: "HOURLY", tgt: "hb-plans-medical-hourly"},
              ]

            }
        },
        methods: {

          goFullscreen: function(){
            this.$refs.container.firstChild.requestFullscreen();
          },

            onSetGuided: function(guided){

                //this.guidedMode = guided;
               //this.showMenu = false;

               this.$store.commit("guidedMode", guided);
              this.$store.commit("showMenu", false);

            },

            onKeyDown: function(e){
                if(e.key == "Shift"){
                    this.showLinks = true;
                }

                if(e.key == " "){
                    this.$store.commit("showMenu", true);
                }
            },

            onKeyUp: function(e){
                console.log(e.key);
                if(e.key == "Shift"){
                    this.showLinks = false;
                }


            },

            onLinkClick: function(e){
               // this.currentScreen = e.target.dataset.tgt;

              if(!e.target.dataset.tgt && this.pulloutPanel) {
                this.pulloutPanel = null;
              }else if(e.target.dataset.isOverlay){
                this.overlayPanel = e.target.dataset.tgt
              }else{
                this.setScreen(e.target.dataset.tgt);
              }


            },

          showPullout: function(e){
            // this.currentScreen = e.target.dataset.tgt;
            this.pulloutPanel = e.target.dataset.tgt
          },

          onSelectClick: function(tgt){
            // this.currentScreen = e.target.dataset.tgt;

              this.setScreen(tgt);



          },

            setScreen: function(id, mode){
                this.overlayPanel = null;
                this.pulloutPanel = null;

                if(!mode){
                  mode = "employee"
                }

                if(id == this.$route.params.screen){
                  //this.$router.go(0);
                }else{
                  this.$router.push({name: mode, params: { screen: id}});
                }

            },

            onFilterEmployees: function(selections){
                console.log(selections);
                this.setScreen('hb-employees-all');
            },

            toggleViz: function(key){
                this.visibility[key] = !this.visibility[key];
            },

            onSideNavLink: function(link){
              if(link){
                let linkParams = link.split(":");
                if(linkParams[0] == "hb"){

                  this.$router.push({name: "employee", params: { screen: linkParams[1]}});

                }else if(linkParams[0] == "dashboard"){

                  this.$router.push({name: "employee", params: { screen: linkParams[1]}});

                }
              }

            },

            onTopNavLink: function(link){


                if(link){
                    let linkParams = link.split(":");
                    if(linkParams[0] == "pullout"){
                        this.showOverlay(linkParams[1]);

                    }
                }

            },

            showOverlay: function(id){
                this.overlayPanel = id;
            }
        },
        computed: {

          showMenu: function(){
            return this.$store.state.showMenu;
          },

          guidedMode: function(){
            return this.$store.state.guidedMode;
          },
            currentScreen: function(){
                if(this.$route.params.screen){
                    return this.$route.params.screen;
                }else{
                    return this.defaultScreen;
                }
            },

            sideNavLink: function(){
               if(this.$route.params.screen){
                   return this.$route.params.screen.split("-")[0];
               }else{
                   return "dashboard";
               }
            },

          sideNavMode: function(){
            if(this.$route.query.mode){
              return this.$route.query.mode;
            }else{
              return "admin";
            }
          }
        }
    }
</script>

<style scoped>

    img {
        margin: 0;
    }

    .demo-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0;
        padding-bottom: calc((920/1580) * 100%);
        max-width: 1580px;
        background-repeat: repeat-y;
        background-image: url(../assets/screen-bkg.png);
        background-size: 100% 10%;

        font-size: 1vw;


    }


    .demo {
        width: 100%;
        position: absolute;
        height: 100%;
        background-repeat: repeat-y;
        background-image: url(../assets/screen-bkg.png);
        background-size: 100% 10%;
        overflow-y:hidden;
        overflow-x: hidden;



    }

    .demo[data-noscroll="true"]{
        overflow-y: hidden;

    }



    .screens {

        position: relative;
        width: 100%;
        height: 100%;
        overflow-y:scroll;
        overflow-x: hidden;
    }

    .overlay {
        position: absolute;
        width: calc((320/1580) * 100%);
        top: calc((60/920) * 100%);
        right: 0;
        display: none;
    }

    .overlay[data-active="true"] {
        display: block;
    }

    .pullout {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      right: 0;
      display: none;
      background-color: rgba(0,0,0,0.49);
    }

    .pullout[data-active="true"] {
      display: block;
    }

    .overlay[data-active="true"] {
      display: block;
    }

    .screens .screen {
        position: relative;
        width: 100%;
        display: none;
    }

    .screen[data-active="true"] {
        display: block;
    }

    .screen .links {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0;
        padding-top: calc((920/1580) * 100%);
    }

    .pullout .links {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 0;
      padding-top: calc((920/1580) * 100%);
    }


    /* UTILITIES */

    .w-full {
        width: 100%;
    }

    .max-w-100 {
        max-width: 1580px;
    }

    .pullout-1200 {
      position: absolute;
      width: calc(100% * (1200 / 3160));
      top: 0;
      right: 0;
    }

    .x-ray {
        opacity: 0.5;
    }

    *[data-hidden] {
        opacity: 0;
    }

    .demo[data-show-links="true"] .screen-link {
        border: 2px solid var(--color-green);
    }

    .demo[data-show-links="true"] .select-box {
      border: 2px solid var(--color-green);
    }

    .demo[data-show-links="true"] .flex-info {
      border: 2px solid var(--color-green);
    }

    .demo[data-show-links="true"] .info-box {
        display: block;
    }

    .demo .info-box {
        display: none;
    }


    .demo[data-guided="true"] .info-box {
        display: block;
    }

    .z-max {
        z-index: 50;
    }

    .z-40 {
        z-index: 40;
    }

    .info-box {
        z-index: 30;
    }





</style>